import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RoutingRulesDialogComponent} from './routing-rules-dialog.component';
import {RoutingRuleDialogAdvancedConditionComponent} from './routing-rule-dialog-advanced-condition/routing-rule-dialog-advanced-condition.component';
import {RoutingRuleDialogDestinationComponent} from './routing-rule-dialog-destination/routing-rule-dialog-destination.component';
import {RoutingRuleDialogRoutingActionsComponent} from './routing-rule-dialog-routing-actions/routing-rule-dialog-routing-actions.component';
import {RoutingRuleDialogSourceComponent} from './routing-rule-dialog-source/routing-rule-dialog-source.component';
import {InfraModule} from 'ac-infra';
import {MaterialModule} from '../../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ChooseTopologyItemModule} from '../../../utils/choose-topology-item/choose-topology-item.module';
import {Ng5SliderModule} from 'ng5-slider';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {EcoFabSpeedDialModule} from '@ecodev/fab-speed-dial';
import {NzIconModule} from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@NgModule({
  declarations: [
    RoutingRulesDialogComponent,
    RoutingRuleDialogAdvancedConditionComponent,
    RoutingRuleDialogDestinationComponent,
    RoutingRuleDialogRoutingActionsComponent,
    RoutingRuleDialogSourceComponent
  ],
  imports: [
    CommonModule,
    InfraModule,
    MaterialModule,
    FormsModule,
    ChooseTopologyItemModule,
    Ng5SliderModule,
    ArmFormTitleModule,
    EcoFabSpeedDialModule,
    NzIconModule,
    NzPopoverModule,
    ReactiveFormsModule
  ]
})
export class RoutingRulesDialogModule { }
